import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import CurrentLocationMap from '../map screens/CurrentLocationMap';

const CurrentLocationDialog = ({
  open,
  onClose,
  setLatLangVal,
  updateLocationFormData,
  setMobileBackColor,
  setMobileTextColor,
  setMobileCardBorderColor
}) => {
  return (
    <Dialog
      className="alignByLang"
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent sx={{
        backgroundColor: setMobileBackColor(),
        color: setMobileTextColor(),
        border: `1px solid ${setMobileCardBorderColor()}`
      }}>
        <CurrentLocationMap
          latlangVal={setLatLangVal}
          closeMapModal={onClose}
          updateLocationFormData={updateLocationFormData}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CurrentLocationDialog;